import moment from 'moment'

function objectIdDate(objectId, format) {
  format = format || 'M/D/YYYY'
  const time = new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
  return moment(time).format(format)
}

export default objectIdDate